// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".547.0.0." + {"1367": "7234ebf82a64cc3a","2257": "edae2c117ffd44a7","2973": "38035b9cc519eb3f","582": "17ee8c70bfa6bdb9","7530": "45dece82f5e68b95","7581": "939794856bf9aee9","8692": "f9a97e5854b8fbad",}[chunkId] + ".css"
}